export default __webpack_public_path__ + "static/abstractions-c1cb8e4a1e00ca34343d9da65063acbe.webp";